var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategorysliderprev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5824_6692)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 50,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-90 4 50)",
    fill: "#7741DE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5824_6692)",
    transform: "rotate(180 29 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 23.4375H36.5938L30.9219 16.625C30.7906 16.467 30.6916 16.2847 30.6308 16.0885C30.5699 15.8922 30.5483 15.6859 30.5672 15.4814C30.6052 15.0682 30.8059 14.6871 31.125 14.4219C31.4441 14.1567 31.8555 14.0291 32.2686 14.0671C32.6818 14.1052 33.0629 14.3059 33.3281 14.625L41.1406 24C41.1932 24.0746 41.2402 24.1529 41.2812 24.2344C41.2813 24.3125 41.3594 24.3594 41.3906 24.4375C41.4614 24.6166 41.4985 24.8074 41.5 25C41.4985 25.1926 41.4614 25.3833 41.3906 25.5625C41.3906 25.6406 41.3125 25.6875 41.2812 25.7656C41.2402 25.8471 41.1932 25.9254 41.1406 26L33.3281 35.375C33.1812 35.5514 32.9972 35.6932 32.7893 35.7904C32.5814 35.8877 32.3545 35.9379 32.125 35.9375C31.7599 35.9382 31.4061 35.8111 31.125 35.5781C30.9668 35.447 30.836 35.2859 30.7401 35.1041C30.6443 34.9223 30.5852 34.7234 30.5663 34.5187C30.5475 34.3141 30.5692 34.1077 30.6302 33.9114C30.6912 33.7152 30.7903 33.5329 30.9219 33.375L36.5938 26.5625H18.0625C17.6481 26.5625 17.2507 26.3979 16.9576 26.1048C16.6646 25.8118 16.5 25.4144 16.5 25C16.5 24.5856 16.6646 24.1882 16.9576 23.8951C17.2507 23.6021 17.6481 23.4375 18.0625 23.4375Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5824_6692",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5824_6692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5824_6692",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5824_6692",
    x: 5.25,
    y: 1.25,
    width: 49.5,
    height: 49.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.728691 0 0 0 0 0.706597 0 0 0 0 0.770833 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5824_6692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5824_6692",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorysliderprev);
export default __webpack_public_path__ + "static/media/categorysliderprev.952a834f.svg";
export { ForwardRef as ReactComponent };